module.exports = __webpack_public_path__ + "img/e982d56.jpg";